import { useEffect, useState } from "react";

const navLinks = [
  { label: "匿名入口", href: "#entry" },
  { label: "投稿方式", href: "#channels" },
  { label: "热门榜单", href: "#ranking" },
  { label: "审核流程", href: "#process" },
  { label: "隐私承诺", href: "#privacy" },
  { label: "常见问题", href: "#faq" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || menuOpen
          ? "border-b border-background-200/70 bg-background-50/95 backdrop-blur"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="flex h-16 items-center justify-between px-4 md:h-20 md:px-8">
        <h1 className="flex items-center">
          <a href="#entry" className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-quill-pen-line text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg tracking-wide text-foreground-950 md:text-xl">
                黑料投稿
              </span>
              <span className="mt-1 font-label text-[10px] uppercase tracking-[0.3em] text-foreground-500">
                Anonymous Tips
              </span>
            </span>
          </a>
        </h1>

        <nav className="hidden items-center gap-7 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="group relative font-label text-sm text-foreground-700 transition-colors hover:text-primary-600"
            >
              {link.label}
              <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-primary-500 transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#channels"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex cursor-pointer"
          >
            匿名投稿
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 md:hidden cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {menuOpen ? (
        <nav className="border-t border-background-200/70 bg-background-50 px-4 pb-6 pt-3 md:hidden">
          <ul className="flex flex-col">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="block border-b border-background-100 py-3.5 font-label text-sm text-foreground-800 transition-colors hover:text-primary-600"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#channels"
            onClick={() => setMenuOpen(false)}
            className="mt-5 flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 font-label text-sm text-background-50"
          >
            前往匿名投稿渠道
          </a>
        </nav>
      ) : null}
    </header>
  );
}